import React, { useEffect, useState } from 'react'
import {
  OtpComponent,
  PropertyCard,
  RoundCard,
  RunnerUpHeader,
  UnderLine,
} from '../../ui'
import Button from '../../library/components/Button'
import {
  useUserApproveMutation,
  useGetRejectByIdQuery,
} from '../../services/nullificationservice'
import { useLocation, useNavigate } from 'react-router'
import { TRY_AFTER_SOME_TIME } from '../../constants/constants'
import { ALERT_TYPE_SUCCESS, ALERT_TYPE_ERROR,ALERT_TYPE_INFO } from '../../constants/constants'
import { useDispatch } from 'react-redux'
import { createAlert } from '../../features/alert/alerts'
import { Validators } from '../../library/utilities/Validator'
import './index.css'
import ConfirmationModal from '../../library/components/FileUpload/ConfirmationModal/ConfirmationModal'
import CustomModal from '../../library/components/Modal/modal'
import { parseJwt } from '../utilities/utils'
import { useOtpSendForEtpbmsMutation, useOtpVerifyForEtpbmsMutation } from '../../services/finalizeGenerateViewTransmitService'
import RunnerUpHeaderNew from '../../ui/runnerUpHeader/RunnerUpHeaderNew'

const Afterapprove = ({
  constNameNoAndState,
  onSendOtpError,
  onRequestApprove,
}) => {
  const location = useLocation()
  const NullificationdataById = useGetRejectByIdQuery(location.state)
  const [UserUpdate] = useUserApproveMutation()
  const [showConfirmationPopup, setConfirmationPopup] = useState(false)
  const [data, setData] = useState([])
  const [errorValue, setErrorValue] = useState({})
  const [otp, setOtp] = useState('')

  const dispatch = useDispatch()
  const propertyCardData = [
    { key: 'State', value: constNameNoAndState.stateName },
    {
      key: 'Election Type',
      value: NullificationdataById?.data?.payload?.electionType,
    },
    {
      key: 'Constituency Type',
      value: NullificationdataById?.data?.payload?.constType,
    },
    {
      key: 'Constituency No. & Name',
      value: `${constNameNoAndState.constNo} - ${constNameNoAndState.constName}`,
    },
  ]

  const officerId = parseJwt(localStorage?.access_token)?.preferred_username
  const mobileNo = parseJwt(localStorage?.access_token)?.phone_number

  const [otpsend, datap] = useOtpSendForEtpbmsMutation()
  const [verifyOtp, datac] = useOtpVerifyForEtpbmsMutation()
  const [isOtpVerified, setIsOtpVerified] = useState(false)

  useEffect(() => {
    otpsend({
      userId:officerId,
      module:"Nullify",
      stateName:constNameNoAndState?.stateName,
      constName:constNameNoAndState?.constName,
      constNo:constNameNoAndState?.constNo
    })
      .unwrap()
      .catch((err) => onSendOtpError())
  }, [])

  const onSuccess = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_SUCCESS,
        heading: 'Success',
      }),
    )
  }
  const onClose = () => {
    setConfirmationPopup(false)
  }

  const onReject = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_ERROR,
        heading: 'Reject',
      }),
    )
  }
  const onInfo = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_INFO,
        heading: "INFO",
      })
    );
  };
  

  const onUpdate = async () => {
    UserUpdate({
      id: location.state,
    })
      .unwrap()
      .then((res) => {
        if (res) {
          onSuccess(res?.message)
          onRequestApprove()
        } else {
          alert(TRY_AFTER_SOME_TIME)
        }
      })
    setConfirmationPopup(false)
  }

  const onVerifyOtp = () => {
    verifyOtp({
      otp: otp,
      userId:officerId,
      module:"Nullify",
      stateName:constNameNoAndState?.stateName,
      constName:constNameNoAndState?.constName,
      constNo:constNameNoAndState?.constNo
    })
      .unwrap()
      .then((res) => {
        if (String(res?.message)?.includes('OTP verified')) {
          setIsOtpVerified(true)
        } else {
          onInfo(res?.message)
        }
      })
  }
  return (
    <>
      {
        <CustomModal
          className="confirmation_modal"
          show={showConfirmationPopup}
          onClose={onClose}
          size="500px"
          closeIcon={false}
          modalTitle={'Do you want to Approve?'}
          children={
            <ConfirmationModal
              // title="You want to delete this"
              noOption={onClose}
              yesOption={onUpdate}
            />
          }
        />
      }
      <div className="after-approve col-md-12">
        <div className="container box shadow ">
          {!isOtpVerified ? (
            <>
              <RunnerUpHeaderNew title={'Verify OTP to proceed'} />
              <p>
                Please enter the OTP received on your Mobile number +91-
                {mobileNo + ' '}
                to Approve selected nullification.
              </p>
              <OtpComponent setOtp={setOtp} otp={otp} />
              <div style={{display: 'flex',justifyContent: 'center'}}>
                <Button
                  btnClass="verify-btn"
                  value="Verify otp"
                  onClick={onVerifyOtp}
                />
              </div>
            </>
          ) : null}
          <UnderLine />
          {isOtpVerified ? (
            <>
              <p>Are you sure you want to Approve?</p>
              <PropertyCard data={propertyCardData} />
              <Button
                value="Approve"
                btnClass="verify-btn"
                onClick={() => setConfirmationPopup(true)}
              />
            </>
          ) : null}
        </div>
      </div>
    </>
  )
}

export default Afterapprove
